import React, {useState, useEffect, useCallback} from 'react';
import { useParams, useLocation, Link } from "react-router-dom";
import { settings } from 'carbon-components';
import { v4 as uuidv4 } from 'uuid';
import classnames from 'classnames';
import Zoom from 'react-medium-image-zoom';
import Cropper from 'react-easy-crop';
import getCroppedImg from '../../Utils/cropImage';

//hooks
import useDeleteImage from '../../Hooks/useDeleteImage';
import useFetchImages from '../../Hooks/useFetchImages';
import useUploadImage from '../../Hooks/useUploadImage';

// utilities
import apiCall from '../../Utils/apiCall';

// npm components

//carbon components
import {
  Grid,
  Row,
  Column,
  Button,
  Loading,
  TextInput,
  StructuredListWrapper,
  StructuredListHead,
  StructuredListRow,
  StructuredListBody,
  StructuredListCell,
  FormItem,
  FileUploaderDropContainer,
  FileUploaderItem,
  handleFileUploaderItemClick,
  Modal,
  Slider,
  ToastNotification
 } from 'carbon-components-react';

 //styles
 import './ImageUploader.css';

 import { Search20, TrashCan20, Crop20 } from '@carbon/icons-react';

const { prefix } = settings;

function ImageUploader(props) {
  //get props
  const { token } = props;
  // get params
  const upcLocation = useLocation();

  //set state
  const [upc, setUpc] = useState("");
  const [itemData, setItemData] = useState(null);
  const [files, setFiles] = useState([]);
  const [cropModalOpen, setCropModalOpen] = useState(false);
  const [imageToCrop, setImageToCrop] = useState("")
  const [crop, setCrop] = useState({ x: 0, y: 0 })
  const [rotation, setRotation] = useState(0)
  const [zoom, setZoom] = useState(1)
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null)
  const [croppedImage, setCroppedImage] = useState(null)
  const [notification, setNotification] = useState(false)
  const [notificationContent, setNotificationContent] = useState({
    title: "",
    caption: "",
    type: "info"
  });

  //hooks
  const {errorImg, loadingImages, images, fetchImgData} = useFetchImages(token);
  const {errorUploadImg, loadingUploadImage, imageToUpload, uploadImage} = useUploadImage(token);
  const {errorDeleteImg, loadingDeleteImage, imageToDelete, deleteImage} = useDeleteImage(token);

  // fetch the data

  //useEffect functions
  useEffect( () => {
    const cleanedUpc = upcLocation.search.substring(1, upcLocation.search.length).split('&')[0].split('=')[1]
    setUpc(cleanedUpc)

    document.addEventListener('drop', handleDrop);
    document.addEventListener('dragover', handleDragover);
    return () => {
      document.removeEventListener('drop', handleDrop);
      document.removeEventListener('dragover', handleDragover);
    };

  }, [])


  useEffect( () => {

    if (!itemData) return

    // console.log("IMAGES", images);
    let itemDataClone = {...itemData};
    itemDataClone.images = images;
    setItemData(itemDataClone);

    return () => {

    };

  }, [images])

  // FUNCTIONS
  //-handlers

  const handleDrop = (e) => {
    e.preventDefault();
  };

  const handleDragover = (e) => {
    e.preventDefault();
  };

  const _handleChangeUpcField = (e) => {
    setItemData(null)
    setUpc(e.target.value)
  }

  const _handleClickUpcSearchButton = async (e) => {

    console.log("SEARCH BUTTON CLICKED");

    //CALL API AND GET ITEM INFO

    const options = {
      method: "GET"
    }
    const headers = {}
    const apiPath = `/items/upc/${upc}`

    const result = await apiCall(token, apiPath, options, headers);

    setItemData(result.item)

  }

  const _handleSubmitUpcSearch = async (e) => {

    if (e.key !== 'Enter') {
      return
    }

    console.log("ENTER PRESSED");

    //CALL API AND GET ITEM INFO

    const options = {
      method: "GET"
    }
    const headers = {}
    const apiPath = `/items/upc/${upc}`

    const result = await apiCall(token, apiPath, options, headers);

    setItemData(result.item)

  }

  const handleFileUploaderItemClick = useCallback(
    (_, { uuid: clickedUuid }) =>
      setFiles(files.filter(({ uuid }) => clickedUuid !== uuid)),
    [files]
  );

  const uploadFile = async (fileToUpload) => {
    // file size validation
    if (fileToUpload.filesize > 1000000) {
      const updatedFile = {
        ...fileToUpload,
        status: 'edit',
        iconDescription: 'Delete file',
        invalid: true,
        errorSubject: 'File size exceeds limit',
        errorBody: '1MB max file size. Select a new file and try again.',
      };
      setFiles((files) =>
        files.map((file) =>
          file.uuid === fileToUpload.uuid ? updatedFile : file
        )
      );
      return;
    }

    // file type validation
    // if (fileToUpload.invalidFileType) {
    //   const updatedFile = {
    //     ...fileToUpload,
    //     status: 'edit',
    //     iconDescription: 'Delete file',
    //     invalid: true,
    //     errorSubject: 'Invalid file type',
    //     errorBody: `"${fileToUpload.name}" does not have a valid file type.`,
    //   };
    //   setFiles((files) =>
    //     files.map((file) =>
    //       file.uuid === fileToUpload.uuid ? updatedFile : file
    //     )
    //   );
    //   return;
    // }

    // simulate network request time
    const rand = Math.random() * 1000;
    setTimeout(() => {
      const updatedFile = {
        ...fileToUpload,
        status: 'complete',
        iconDescription: 'Upload complete',
      };
      setFiles((files) =>
        files.map((file) =>
          file.uuid === fileToUpload.uuid ? updatedFile : file
        )
      );
    }, rand);

    // show x icon after 1 second
    setTimeout(() => {
      const updatedFile = {
        ...fileToUpload,
        status: 'edit',
        iconDescription: 'Delete file',
      };
      setFiles((files) =>
        files.map((file) =>
          file.uuid === fileToUpload.uuid ? updatedFile : file
        )
      );
    }, rand + 1000);
  };

  const onAddFiles = useCallback(
    (evt, { addedFiles }) => {
      evt.stopPropagation();
      const newFiles = addedFiles.map((file) => {

      return ({
        uuid: uuidv4(),
        name: file.name,
        filesize: file.size,
        status: 'uploading',
        iconDescription: 'Uploading',
        fileobj: file
      })});
      // eslint-disable-next-line react/prop-types
      if (true) { //multiple = true
        setFiles([...files, ...newFiles]);
        newFiles.forEach(uploadFile);
      } else if (newFiles[0]) {
        setFiles([newFiles[0]]);
        uploadFile(newFiles[0]);
      }
    },
    // eslint-disable-next-line react/prop-types
    [files, true]
  );

  const _handleUploadFilesToServer = (e) => {

    if (files.length === 0) {
      console.log("[*] Files are empty", files);
      return
    }

    let filesToUpload = files.map((file, i) => {
      return file.fileobj;
    })

    console.log("SAVING", filesToUpload);
    uploadImage(filesToUpload, upc, fetchImgData);
    setFiles([])

    if (errorImg) {
      setNotification(true)
      setNotificationContent({
        title: "Error",
        caption: "Error uploading image.",
        type: "error"
      })
      setTimeout( () => {
        setNotification(false)
      }, 3000 )
    } else {
      setNotification(true)
      setNotificationContent({
        title: "Success",
        caption: "Image succesfully uploaded.",
        type: "success"
      })
      setTimeout( () => {
        setNotification(false)
      }, 3000 )
    }

  }

  //method to handle the image delete
  const _handleImgDelete = (imgKey, imgUpc, e) => {
    e.preventDefault()
    console.log(imgKey);
    const imgName = imgKey.split('/')[1]
    console.log("-------------");
    console.log("DELETING", imgName, "of", imgUpc);

    let confirmed = window.confirm(`Are you sure you want to delete this image?`)
    if (confirmed === false ) return

    deleteImage(imgName, imgUpc, fetchImgData);

    if (errorDeleteImg) {
      setNotification(true)
      setNotificationContent({
        title: "Error",
        caption: "Error deleting image.",
        type: "error"
      })
      setTimeout( () => {
        setNotification(false)
      }, 3000 )
    } else {
      setNotification(true)
      setNotificationContent({
        title: "Success",
        caption: "Image succesfully deleted.",
        type: "success"
      })
      setTimeout( () => {
        setNotification(false)
      }, 3000 )
    }

  }

  const _handleImgResize = (imgKey, imgUpc, e) => {
    e.preventDefault();
    const imgUrl = `https://cwc-product-images-s3-bucket.s3.amazonaws.com/${imgKey}`
    setImageToCrop(imgUrl);
    setCropModalOpen(true)
    return
  }

  const labelClasses = classnames(`${prefix}--file--label`, {
    // eslint-disable-next-line react/prop-types
    [`${prefix}--file--label--disabled`]: props.disabled,
  });

  const helperTextClasses = classnames(`${prefix}--label-description`, {
    // eslint-disable-next-line react/prop-types
    [`${prefix}--label-description--disabled`]: props.disabled,
  });

  // image manipulation functions (cropping zooming rotating saving)

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels)
  }, [])

  const showCroppedImage = useCallback(async () => {
    try {
      const croppedImage = await getCroppedImg(
        imageToCrop,
        croppedAreaPixels,
        rotation
      )
      // console.log('done cropping', { croppedImage })
      setCroppedImage(croppedImage)

      uploadImage([croppedImage], upc, fetchImgData);
      setTimeout(() => {
        setCropModalOpen(false);
        setImageToCrop("");
      }, 500)

      if (errorImg) {
        setNotification(true)
        setNotificationContent({
          title: "Error",
          caption: "Error cropping image.",
          type: "error"
        })
        setTimeout( () => {
          setNotification(false)
        }, 3000 )
      } else {
        setNotification(true)
        setNotificationContent({
          title: "Success",
          caption: "Image succesfully cropped.",
          type: "success"
        })
        setTimeout( () => {
          setNotification(false)
        }, 3000 )
      }


    } catch (e) {
      console.error(e)
    }
  }, [croppedAreaPixels, rotation])




  //-render functions
  const renderItemDataCard = () => {

    return (
      <div id="upcAndItemInfoCard">
        <h4>Item Details</h4>
        <div id="itemDataPanelContainer">
          <p><strong>UPC: </strong>{itemData.item.upc}</p>
          <p><strong>ITEM NUMBER: </strong>{itemData.item.itemNumber}</p>
          <p><strong>CATEGORY: </strong>{itemData.item.itemClass ? itemData.item.itemClass : "N/A"}</p>
          <p><strong>SUBCATEGORY: </strong>{itemData.item.itemPriceClass ? itemData.item.itemPriceClass : "N/A"}</p>
          <p><strong>DESCRIPTION: </strong>{itemData.item.description}</p>
          <p><strong>PACKET SIZE: </strong>{itemData.item.packSize}</p>
          <p><strong>SELLING UM: </strong>{itemData.item.sellUOM}</p>
        </div>
      </div>
    )
  }

  const renderFileUploadCard = () => {
    return (
      <div id="fileUploadCard">
        <h4 id="uploadCardMainTitle">Upload Images</h4>
        <FormItem>
          <p className={helperTextClasses}>
            Drag and drop multiple files up to 1MB each. Supported file types include .jpg and .png formats.
          </p>
          <FileUploaderDropContainer {...props} onAddFiles={onAddFiles} />
          <div className={`${prefix}--file-container`} style={{ width: '100%' }}>
            {files.map(
              ({
                uuid,
                name,
                filesize,
                status,
                iconDescription,
                invalid,
                ...rest
              }) => (
                <FileUploaderItem
                  key={uuidv4()}
                  uuid={uuid}
                  name={name}
                  filesize={filesize}
                  size={props.size}
                  status={status}
                  iconDescription={iconDescription}
                  invalid={invalid}
                  onDelete={handleFileUploaderItemClick}
                  {...rest}
                />
              )
            )}
          </div>
          <Button id="addImgToDatabaseBtn" onClick={(e) => _handleUploadFilesToServer(e)}>Upload Files</Button>
          </FormItem>

      </div>
    )
  }

  const renderExistingImgsCard = () => {

    let imgElements;

    if (!itemData.images || loadingImages) {
      return (
        <div id="outerItemImagesCardContainer">
          <h4>Current Images</h4>
            <div id="imgBoxLoadingContainer">
              <Loading active={true} id="loadingImagesSpinner" withOverlay={false} />
            </div>
        </div>
      )
    }

    imgElements = itemData.images.map( (img, i) => {
      return (
        <div key={i} className="ImgActionBtnsContainer">
          <div className="itemImgContainer">
            <Zoom zoomMargin={40}>
              <img className="imagesOfItem" src={`https://cwc-product-images-s3-bucket.s3.amazonaws.com/${img.Key}?${new Date().getTime()}`} />
            </Zoom>
          </div>
          <div className="deleteBtnWrapper">
            <a className={"imgCropBtn"} onClick={(e) => _handleImgResize(img.Key, itemData.item.upc, e)} href="#"><Crop20 /></a>
            <a className={"imgDeleteBtn"} onClick={(e) => _handleImgDelete(img.Key, itemData.item.upc, e)} href="#"><TrashCan20 /></a>
          </div>
        </div>
      )
    })

    return (
      <div id="outerItemImagesCardContainer">
        <h4>Current Images</h4>
        <div id="itemImagesCardContainer">
          {imgElements}
        </div>
      </div>
    )
  }


  // condtional renderings


  // main render

  return (
    <div id="imageUploaderContainer">

      { notification ?  <ToastNotification lowContrast={false} className="appNotification slide-in-top" title={notificationContent.title} kind={notificationContent.type} caption={notificationContent.caption} /> : null }

      <h3 id="imgUplMainTitle">Image Management</h3>
      <Grid>
        <Row>
          <Column>
            <div id="ColContainer">

              <div id="searchInputAndButtonCont">
                <TextInput
                  id="upcInput"
                  labelText="UPC"
                  placeholder="000000000000"
                  defaultValue={upc}
                  onChange={(e) => _handleChangeUpcField(e)}
                  onKeyDown={(e) => _handleSubmitUpcSearch(e)}
                />

              <Button id="searchUpcButton" renderIcon={Search20} onClick={() => _handleClickUpcSearchButton()} size="small" iconDescription="Search UPC" hasIconOnly tooltipAlignment={"end"} tooltipPosition="top" ></Button>

              </div>

              {itemData ? renderItemDataCard() : null}


              {itemData ? renderExistingImgsCard() : null}

              {itemData ? renderFileUploadCard() : null}

            </div>







          </Column>

        </Row>
      </Grid>


      <Modal
        id="cropImageModal"
        aria-label={"Crop Image modal"}
        open={cropModalOpen}
        onRequestClose={(e) => setCropModalOpen(false)}
        hasScrollingContent={true}
        primaryButtonText={"Save Image"}
        secondaryButtonText={"Cancel"}
        onRequestSubmit={showCroppedImage}
      >
      <div id="globalCropContainer">
        <div className={"cropContainer"}>
          <Cropper
            labelText={"Change Zoom"}
            image={imageToCrop}
            crop={crop}
            rotation={rotation}
            zoom={zoom}
            aspect={1 / 1}
            onCropChange={setCrop}
            onRotationChange={setRotation}
            onCropComplete={onCropComplete}
            onZoomChange={setZoom}
          />
        </div>
        <div id="slidersContainer">
          <div className="theSliders" id="zoomSlidercontainer">
            <Slider
              name="Zoom slider"
              id="theZoomSlider"
              inputType="number"
              labelText="Zoom"
              ariaLabelInput="Zoom Slider"
              min={1}
              minLabel={""}
              max={3}
              maxLabel={""}
              onChange={(e) => setZoom(e.value)}
              step={0.1}
              value={zoom}
              hideTextInput={true}
            />
          </div>
          <div className="theSliders" id="rotationSliderContainer">
            <Slider
              name="Zoom slider"
              id="theZoomSlider"
              inputType="number"
              labelText="Rotation"
              ariaLabelInput="Zoom Slider"
              min={0}
              minLabel={""}
              max={360}
              maxLabel={""}
              onChange={(e) => setRotation(e.value)}
              step={1}
              value={rotation}
              hideTextInput={true}
            />
          </div>
        </div>
      </div>
      </Modal>


    </div>

  );
}

export default ImageUploader;
